import type { History } from './';
import type { StateHistoryRecord } from './history.schema';
import type { HistoryRecord } from './history.ruleset';

/**
 * Return history records
 */
export function getHistory(state: History.State): HistoryRecord[] {
  return ([...state.history] as StateHistoryRecord[]) as HistoryRecord[];
}
